// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2tcMe","alert":"SettungsInbox_alert__KWUed"};